import React, { FC } from 'react';
import { SemResultsPageTrackingProvider } from '../TrackingProviders';
import SemLocationsProvider from './SemLocationsProvider';
import SemSortingProvider, {
  SemSortedItinerariesProvider,
} from './SemSortingProvider';
import FeeTypeProvider from '../FeeTypeProvider';
import SemSearchRequestProvider from './SemSearchRequestProvider';

import { SemParsedSearchResponseProvider } from '../ParsedSearchResponseProvider';
import SemSearchResponseProvider from './SemResponseProvider';
import ItinerariesPricesProvider from '../ItinerariesPricesProvider';
import ItineraryTripProvider from '../ItineraryTripProvider';
import SemFiltersProvider from './SemFiltersProvider';
import { ShoppingBundleProvider } from '../ShoppingBundleProvider';
import ItinerarySelectionProvider from '../ItinerarySelectionProvider';
import { SemDisplayedItinerariesProvider } from '../DisplayedItinerariesProvider';
import { SemFilteredItinerariesProvider } from '../FilteredItinerariesProvider/index';
import SemItinerarySelectionProvider from './SemItinerarySelectionProvider';
import SemSearchRequestHashProvider from './SemSearchRequestHashProvider';
import SearchTrackerProvider from '../SearchTrackerProvider';
import SemFiltersBottomDrawerProvider from '../SemFiltersBottomDrawerProvider';

type SemResultsProviderType = {
  onFeeTypeChange?: () => void;
  itinerarySelectionActions?: {
    continueToPassengers: () => void;
    continueWithHotel: () => void;
    recoverSearchRequest: () => void;
  };
  endSemSearchMetric?: () => void;
  itineraryFromUrl: Record<string, unknown>;
};

const noop = (): void => {};
const defaultItinerarySelectionActions = {
  continueToPassangers: noop,
  continueWithHotel: noop,
  recoverSearchRequest: noop,
};

const SemResultsProvider: FC<SemResultsProviderType> = ({
  onFeeTypeChange = noop,
  itinerarySelectionActions = defaultItinerarySelectionActions,
  endSemSearchMetric = noop,
  itineraryFromUrl,
  children,
}) => {
  return (
    <SemResultsPageTrackingProvider>
      <SearchTrackerProvider endSearchMetric={endSemSearchMetric}>
        <SemSearchRequestHashProvider>
          <SemLocationsProvider>
            <FeeTypeProvider onChange={onFeeTypeChange}>
              <SemSearchRequestProvider>
                <SemSearchResponseProvider>
                  <SemParsedSearchResponseProvider>
                    <ItinerariesPricesProvider>
                      <SemFiltersProvider>
                        <SemSortingProvider>
                          <SemSortedItinerariesProvider>
                            <SemFilteredItinerariesProvider>
                              <SemDisplayedItinerariesProvider>
                                <ItineraryTripProvider>
                                  <ShoppingBundleProvider
                                    actions={itinerarySelectionActions}
                                  >
                                    <ItinerarySelectionProvider
                                      itineraryFromUrl={itineraryFromUrl}
                                    >
                                      <SemItinerarySelectionProvider>
                                        <SemFiltersBottomDrawerProvider>
                                          {children}
                                        </SemFiltersBottomDrawerProvider>
                                      </SemItinerarySelectionProvider>
                                    </ItinerarySelectionProvider>
                                  </ShoppingBundleProvider>
                                </ItineraryTripProvider>
                              </SemDisplayedItinerariesProvider>
                            </SemFilteredItinerariesProvider>
                          </SemSortedItinerariesProvider>
                        </SemSortingProvider>
                      </SemFiltersProvider>
                    </ItinerariesPricesProvider>
                  </SemParsedSearchResponseProvider>
                </SemSearchResponseProvider>
              </SemSearchRequestProvider>
            </FeeTypeProvider>
          </SemLocationsProvider>
        </SemSearchRequestHashProvider>
      </SearchTrackerProvider>
    </SemResultsPageTrackingProvider>
  );
};

export default SemResultsProvider;
